import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const updateGroup = createAsyncThunk("updateGroup", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`/groups/${id}`, data);
		return response.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Failed to update group");
	}
});

export const removeGroupUsers = createAsyncThunk("removeGroupUsers", async ({ id, userIds }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`/groups/${id}/users/remove`, { userIds });
		return response.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Failed to remove user");
	}
});

const GroupUpdateSlice = createSlice({
	name: "GroupUpdateSlice",
	initialState: {
		isLoading: false,
		removeLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetGroupUpdate: (state) => {
			state.isLoading = false;
			state.removeLoading = false;
			state.data = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updateGroup.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(updateGroup.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(updateGroup.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});

		builder.addCase(removeGroupUsers.pending, (state) => {
			state.removeLoading = true;
			state.error = null;
		});

		builder.addCase(removeGroupUsers.fulfilled, (state, action) => {
			state.removeLoading = false;
			state.data = action.payload;
		});

		builder.addCase(removeGroupUsers.rejected, (state, action) => {
			state.removeLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetGroupUpdate } = GroupUpdateSlice.actions;

export default GroupUpdateSlice.reducer;
